import axios from 'axios';
import { getAxiosGetRequest } from '../apiHelpers';

export const apiGetVersionPromise = () => {
    return axios(getAxiosGetRequest(['version', 'spa'])).then(response => {
        return response;
    });
};
